/** Utilitários de DOM. Sem framework: cada feature desenha seu template e liga seus eventos. */

/** Busca obrigatória: lança erro se o elemento não existir (evita `!` espalhado). */
export function q<T extends Element = HTMLElement>(sel: string, root: ParentNode = document): T {
  const el = root.querySelector<T>(sel);
  if (!el) throw new Error(`Elemento não encontrado: ${sel}`);
  return el;
}

/** Busca opcional. */
export function qo<T extends Element = HTMLElement>(sel: string, root: ParentNode = document): T | null {
  return root.querySelector<T>(sel);
}

export function qa<T extends Element = HTMLElement>(sel: string, root: ParentNode = document): T[] {
  return Array.from(root.querySelectorAll<T>(sel));
}

/** Escapa texto para interpolação segura em templates. */
export const esc = (s: unknown): string =>
  String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c] as string);

/** Delegação de eventos: `delegate(root, 'click', '[data-x]', (el, ev) => …)`. */
export function delegate<E extends Event = MouseEvent>(
  root: Element,
  type: string,
  selector: string,
  handler: (el: HTMLElement, ev: E) => void
): void {
  root.addEventListener(type, ev => {
    const target = ev.target as Element | null;
    const el = target?.closest<HTMLElement>(selector);
    if (el && root.contains(el)) handler(el, ev as E);
  });
}

export function show(el: HTMLElement, visible: boolean): void {
  el.hidden = !visible;
}

export const inputValue = (sel: string): string => q<HTMLInputElement>(sel).value.trim();
export const setInputValue = (sel: string, v: string): void => { q<HTMLInputElement>(sel).value = v; };
